import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export default function removeFileType(fileName) {
  // Remove file type extension from file name
  return fileName.replace(/\.[^.]*$/gi, '');
}